var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userInfo && _vm.userInfo.admin)?_c('div',[_c('newGroup',{staticClass:"ma-3"}),(_vm.all_groups.length > 0)?_c('div',_vm._l((_vm.all_groups),function(group,index){return _c('div',{key:index,staticClass:"ma-1"},[_c('oneGroup',{key:index,attrs:{"group":group},on:{"remove":_vm.remove}})],1)}),0):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }